export default {
    LANGUAGE_CHANGED: 'LANGUAGE_CHANGED',
    HIDE_TOOLTIP: 'HIDE_TOOLTIP',
    CREATIONS: 'CREATIONS',
    HISTORY: 'HISTORY',
    WARNING: 'warning',
    GET_CREDITS: 'get_credits',
    CANCEL: 'cancel',
    SUBMIT: 'submit',
    FACEBOOK: 'FACEBOOK',
    TWITTER: 'TWITTER',
    GRADIENT: 'gradient',
    TUMBLR: 'TUMBLR',
    COPY_LINK: 'COPY_LINK',
    REC_ID: 'rec_id',
    UPDATE_USER_CREDITS: 'UPDATE_USER_CREDITS',
    LOADING: 'LOADING',
    DEFAULT: 'DEFAULT',
    GENERATING: 'GENERATING',
    START: 'START',
    WAITING: 'WAITING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    FACE: 'faces',
    ENTIRETY: 'general_scenes',
    SMALL: 'SMALL',
    SETTING: 'SETTING',
    EXPORTING: 'EXPORTING',
    UPLOADING: 'UPLOADING',
    PROGRESS: 'PROGRESS',
    INIT_PROJECT: 'INIT_PROJECT',
    TEXT_TO_IMAGE_MODAL: 'TEXT_TO_IMAGE_MODAL',
    TEXT_TO_IMAGE_RATIO: 'TEXT_TO_IMAGE_RATIO',
    TEXT_TO_IMAGE_GENERATE_NUMBER: 'TEXT_TO_IMAGE_GENERATE_NUMBER',
    TEXT_TO_IMAGE_STYLE: 'TEXT_TO_IMAGE_STYLE',
    TEXT_TO_IMAGE_AI_PROMPT: 'TEXT_TO_IMAGE_AI_PROMPT',
    CHANGE_START: 'changeStart',
    CHANGE: 'change',
    CHANGE_END: 'changeEnd',
    CLICK: 'click',

    LOCAL: 0,
    AI_VIDEO_S3: 1,
    AI_VIDEO_TEXT_IMAGE_S3: 2,
    AI_VIDEO_IMAGE_IMAGE_S3: 3,
    AI_VIDEO_FLEXCLIP: 4,
    BEFORE: 'BEFORE',
    COMPARE: 'COMPARE',
    AFTER: 'AFTER',
    ACCOUNT_CHANGE: 'ACCOUNT_CHANGE',
    USER_SPACE_CHANGE: 'USER_SPACE_CHANGE',

    ALL: 'ALL',
    VOCAL: 'VOCAL',
    INSTRUMENTAL: 'INSTRUMENTAL',
    SOUND_EFFECT: 'SOUND_EFFECT',
    PLAY: 'PLAY',
    PAUSE: 'PAUSE',

    NO_DEVICE_LIST: 'NO_DEVICE_LIST',
    NO_PERMISSION: 'NO_PERMISSION',
    RECORDING: 'RECORDING',

    AI_AUDIO_S3: 1,
    AI_AUDIO_FLEXCLIP: 2,

    RETRY: 'RETRY',
    SOURCE_LOADING_ERROR: 'SOURCE_LOADING_ERROR',

    AUDIO_TAG_TYPE_SFX: 'AUDIO_TAG_TYPE_SFX',
    AUDIO_TAG_TYPE_MUSIC: 'AUDIO_TAG_TYPE_MUSIC',
    AUDIO_TAG_TYPE_INST: 'AUDIO_TAG_TYPE_INST',

    BUSY: 'BUSY',
    CLOSE: 'CLOSE',
    DISCOUNT: 'DISCOUNT',

    SMALL_MODAL: 'SMALL_MODAL',

    STEP_TYPE_HOME: 'STEP_TYPE_HOME',
    STEP_TYPE_SCRIPTS_PASTE: 'STEP_TYPE_SCRIPTS_PASTE',
    STEP_TYPE_SCRIPTS_EDIT: 'STEP_TYPE_SCRIPTS_EDIT',
    STEP_TYPE_VIDEO_SETTINGS: 'STEP_TYPE_VIDEO_SETTINGS',
    AI_GENERATED: 'AI_GENERATED',
    STOCK_LIBRARY: 'STOCK_LIBRARY',
    IMAGE_AND_VIDEO_MIXING: 'IMAGE_AND_VIDEO_MIXING',
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO',
    SORT_TYPE_RELEVANT: 'SORT_TYPE_RELEVANT',

    IDLE: 'IDLE',
    PLAYING: 'PLAYING',
    TWO_ROW: 'TWO_ROW',
    ONE_ROW: 'ONE_ROW',
    GRAY: 'GRAY',
    WHITE: 'WHITE',
};
